import { isAcme } from 'isAcme';

import {
  requiredColumns as requiredColumnsACME,
  availableColumns as availableColumnsACME,
  fieldData as fieldDataACME,
  columnDefaults as columnDefaultsACME,
  clrFieldOptions as clrFieldOptionsACME,
  recurringEditable as recurringEditableACME,
  flagFieldOptions as flagFieldOptionsACME,
} from './transactionsConfigACME';

import {
  requiredColumns as requiredColumnsQUICKEN,
  availableColumns as availableColumnsQUICKEN,
  fieldData as fieldDataQUICKEN,
  columnDefaults as columnDefaultsQUICKEN,
  clrFieldOptions as clrFieldOptionsQUICKEN,
  recurringEditable as recurringEditableQUICKEN,
} from './transactionsConfigQUICKEN';

export function getColumnDefaults(type = 'default') {
  const defaults = isAcme ? columnDefaultsACME : columnDefaultsQUICKEN;
  const key = type && type.toLowerCase();
  return defaults[key] || defaults.default;
}

export function getAvailableColumns(type = 'default') {
  const defaults = isAcme ? availableColumnsACME : availableColumnsQUICKEN;
  const key = type && type.toLowerCase();
  return defaults[key] || defaults.default;
}

export const requiredColumns = isAcme ? requiredColumnsACME : requiredColumnsQUICKEN;
export const availableColumns = isAcme ? availableColumnsACME : availableColumnsQUICKEN;
export const fieldData = isAcme ? fieldDataACME : fieldDataQUICKEN;
export const clrFieldOptions = isAcme ? clrFieldOptionsACME : clrFieldOptionsQUICKEN;
export const recurringEditable = isAcme ? recurringEditableACME : recurringEditableQUICKEN;
export const flagFieldOptions = isAcme ? flagFieldOptionsACME : null;

